import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../../styles/modals/validationToastModal.css';

const ValidationToastModal = ({ message, isOpen, onClose, targetElement }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  
  useEffect(() => {
    console.log('[ValidationToastModal 디버깅] Props 변경:', { message, isOpen, targetElement: targetElement ? '있음' : '없음' });
    
    if (isOpen) {
      // 화면 중앙에 배치하는 방식으로 변경
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      
      const newPosition = {
        top: viewportHeight * 0.5,
        left: viewportWidth * 0.5
      };
      
      console.log('[ValidationToastModal 디버깅] 화면 중앙 위치 계산:', {
        viewport: {
          width: viewportWidth,
          height: viewportHeight
        },
        calculatedPosition: newPosition
      });
      
      setPosition(newPosition);
      
      // 2초 후 자동 닫기
      const timer = setTimeout(() => {
        console.log('[ValidationToastModal 디버깅] 2초 타이머 완료, 닫기 함수 호출');
        onClose();
      }, 2000);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, targetElement, onClose, message]);
  
  // 렌더링 로그
  useEffect(() => {
    console.log('[ValidationToastModal 디버깅] 렌더링 상태:', { 
      isOpen, 
      position, 
      cssClass: `validation-toast-modal ${isOpen ? 'visible' : 'hidden'}` 
    });
  }, [isOpen, position]);
  
  if (!isOpen) {
    console.log('[ValidationToastModal 디버깅] 모달이 닫혀있어 렌더링하지 않음');
    return null;
  }
  
  console.log('[ValidationToastModal 디버깅] 모달 렌더링 중');
  
  return (
    <div 
      className="validation-toast-modal fixed-center"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        display: isOpen ? 'block' : 'none' // 명시적으로 표시 상태 설정
      }}
    >
      <div className="validation-toast-content">
        <div className="validation-toast-message">{message}</div>
      </div>
    </div>
  );
};

ValidationToastModal.propTypes = {
  message: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  targetElement: PropTypes.object
};

export default ValidationToastModal; 